/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
// Library Imports
import { useState, useEffect } from "react";
import styled from "styled-components";

// import { Option } from "antd/lib/mentions";
import { useDispatch, useSelector } from "react-redux";
// Local Imports
import { RootState } from "store";
import Plus from "../../../../assets/img/icons/plus-5.svg";
import {
  ControlNameEnum,
  ConditionEmails,
  IControls,
  ConditionEnum,
  IShareProfileTemplate,
} from "../../interfaces";
import { findDropAreaData, getConditionEmails, getConditionNodes } from "../../utils";
import ConditionSelection from "../ConditionSelection";
import { clearDropArea, updateErrorNodes } from "modules/Automation/actions";
import { addActionModal, addNode, editNode } from "./../../actions";

type IConditionProps = {
  id: string;
  enableSaveButton: (value: boolean) => void;
  handleSaveButton: (conditions: object[]) => void;
  activeKey: string;
};

type IConditionControls = {
  id: string;
  value: ConditionEnum.HAS_CLICKED | ConditionEnum.HAS_OPENED;
  label: ConditionEnum.HAS_CLICKED | ConditionEnum.HAS_OPENED;
};

const IfElseContent = (props: IConditionProps) => {
  // Props
  const { id, enableSaveButton, handleSaveButton, activeKey } = props;

  // Redux States
  const controls: IControls[] = useSelector((state: RootState) => state.automation.controls);
  const itemData = useSelector((state: RootState) => state.automation.workflow.flow[id]?.detail);
  const dropData = useSelector((state: RootState) => state.automation.workflow.dropArea);
  const modal = useSelector((state: RootState) => state.automation.modals.addAction);

  const shareProfileTemplates: IShareProfileTemplate[] = useSelector(
    (state: RootState) => state.automation.emails.shareProfileTemplates
  );

  // Local Variables
  const dispatch = useDispatch();
  const emails: ConditionEmails[] = getConditionEmails(dropData.id || id, shareProfileTemplates);
  const nodes: any = getConditionNodes(dropData.id || id);
  let conditionControls: IConditionControls[] = controls
    .find((control: IControls) => control.name === ControlNameEnum.IF_ELSE)
    ?.conditions?.filter(condition => condition.id !== 12 && condition.id !== 13)
    ?.map((condition) => {
      return {
        id: condition.id,
        value: condition.name,
        label: condition.name,
      };
    }) || [{ id: "", value: "", label: "" }];
  const initialCondition = [
    {
      emailId: 0,
      emailType: "",
      emailName: "",
      link: "",
      linkType: "",
      sp_uuid: "",
      controlId: 3,
      controlName: ConditionEnum.HAS_OPENED,
    },
  ];
  const isConditionModalOpen = modal.visible === true && modal.tab === ControlNameEnum.IF_ELSE;
  let dependencies = itemData && isConditionModalOpen;

  // Local States
  const [conditions, setConditions] = useState(initialCondition);
  const [conditionOperators, setConditionOperators] = useState<any>([]);

  // UseEffects
  useEffect(() => {
    updateCurrentStates();
  }, [dependencies, emails.length, id]);

  useEffect(() => {
    // Save button enable disable handling on switching consditions tabs
    if (activeKey === ControlNameEnum.IF_ELSE)
      handleSaveButton(conditions);
  }, [activeKey]);

  useEffect(() => {
    if (modal.visible === false) {
      enableSaveButton(false);
      resetUpdate();
    }
  }, [modal]);

  // Component Logic
  const onAddCondition = () => {
    let updatedConditions = [
      ...conditions,
      {
        emailId: 0,
        emailType: "",
        emailName: "",
        link: "",
        linkType: "",
        sp_uuid: "",
        controlId: 3,
        controlName: ConditionEnum.HAS_OPENED,
      },
    ];
    setConditions([...updatedConditions]);
    if (conditionOperators?.includes("OR")) {
      setConditionOperators((state: any) => [...state, "OR"]);
    } else {
      setConditionOperators((state: any) => [...state, "AND"]);
    }
    handleSaveButton(updatedConditions);
  };

  const removeCondition = (index: number) => {
    let filteredConditions = [...conditions].filter((con, idx) => idx !== index);
    setConditions(filteredConditions);
    let updatedConditionOperators = [...conditionOperators];
    updatedConditionOperators.pop();
    setConditionOperators([...updatedConditionOperators]);

    handleSaveButton(filteredConditions);
  };

  const updateNode = (condition: any, index: number) => {
    let updatedConditions = [...conditions];
    // if (index > -1) {
    if (updatedConditions[index]) {
      updatedConditions[index] = condition;
      setConditions([...updatedConditions]);
    }
    handleSaveButton(updatedConditions);
  };

  const resetUpdate = () => {
    setConditions(initialCondition);
    setConditionOperators([]);
  };

  const updateCurrentStates = () => {
    if (id && itemData) {
      if (itemData.conditions) {
        let conditionsArray = [...itemData.conditions];
        let updated = conditionsArray.map((condition) => {
          let conditionObject = { ...condition };
          let emailId = conditionObject?.emailId;
          let indexOfEmail = emails.findIndex(
            (email) =>
              email?.emailId?.toString() === emailId?.toString() ||
              email?.sp_uuid?.toString() === emailId?.toString()
          );
          if (indexOfEmail < 0) {
            conditionObject.emailId = 0;
            conditionObject.emailName = "";
            conditionObject.emailType = "";
            conditionObject.sp_uuid = "";
            conditionObject.link = "";
            conditionObject.linkType = "";
          }
          return conditionObject;
        });
        setConditions([...updated]);
        handleSaveButton(itemData.conditions);
        if (itemData?.conditionOperators.length > 0) {
          setConditionOperators([...itemData?.conditionOperators]);
        }
      }
    } else {
      if (conditions.length > 1) {
        setConditions(initialCondition);
        setConditionOperators([]);
      }
    }
  };

  const submitHandler = (event: any) => {
    event.preventDefault();
    let obj = findDropAreaData(ControlNameEnum.IF_ELSE);
    let conditionTime = "5m";
    let title = "title";
    if (id) {
      // edit Node
      dispatch(
        editNode(id, {
          ...itemData,
          nodeTitle: title && title?.includes("undefined") ? "Share Profile" : title,
          conditionOperators,
          error: false,
          conditions: conditions,
          conditionTime,
        })
      );
      dispatch(updateErrorNodes(id));
    } else {
      dispatch(
        addNode({
          ...obj,
          conditionOperators,
          nodeTitle: title,
          conditions: conditions,
          conditionTime,
        })
      );
    }
    enableSaveButton(false);
    dispatch(addActionModal(false));
    dispatch(clearDropArea());
  };

  return (
    <Wrapper>
      {/* WF Name changes done here */}
      <div className="label-model">Condition</div>
      <form id={`${ControlNameEnum.IF_ELSE}`} onSubmit={submitHandler}>
        <div className="condition-wrapper">
          <div className="label-condition padding-styles">Select a condition</div>
          {conditions.map((condition, index) => (
            <ConditionSelection
              id={id}
              key={index}
              index={index}
              emails={emails}
              nodes={nodes}
              condition={condition}
              conditions={conditions}
              conditionOperators={conditionOperators}
              setConditions={setConditions}
              setConditionOperators={setConditionOperators}
              enableSaveButton={enableSaveButton}
              conditionControls={conditionControls}
              isAdditional={index !== 0}
              removeCondition={removeCondition}
              updateNode={updateNode}
            />
          ))}
          <div className="add-condition-wrapper">
            <div className="add-condition-button" onClick={onAddCondition}>
              <img src={Plus} alt="" /> Add another condition
            </div>
          </div>
        </div>
      </form>
    </Wrapper>
  );
};

export default IfElseContent;

const Wrapper = styled.div`
  .condition-wrapper {
    /* height: calc(100vh - 400px); */
    height: 490px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    width: calc(100% + 10px) !important;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      /* height: calc(100vh - 240px); */
      height: 415px;
    }
    margin-left: -10px;
    padding-left: 10px;
    padding-right: 30px;
    padding-bottom: 50px;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 15px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #01218a;
    }
    .padding-styles{
      padding-top: 15px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        padding-top: 18px;
      }
    }
    .ant-select-item-group {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      letter-spacing: -0.4px;
      color: #424b50;
      .ant-select-item-option-content {
        color: #979797;
      }
    }
    .ant-select-item-option-content,
    .ant-select-selection-item {
      color: #979797;
      span {
        align-items: center;
        display: flex;
        color: #979797;
        font-family: "Roboto";
        font-size: 12px;
        text-decoration: underline;
        text-decoration-color: #979797;
        width: 100%;
        .ant-typography-ellipsis-single-line {
          margin-bottom: 0;
          text-decoration: underline;
          color: #979797;
          text-decoration-color: #979797;
        }
        .read-more {
          font-size: 12px;
          color: #27ce0a;
          margin-top: 0;
          margin-bottom: 0;
          text-decoration: underline;
        }
      }
      :hover {
        color: #979797;
      }
    }
    /* .ant-select-item-option-content{
      .ant-typography p {
        margin-bottom: 0;
      }
      font-family: 'Roboto';
      font-size: 12px;
      text-decoration: underline;
      text-decoration-color: #979797;
    } */
    .ant-select-selection-item {
      max-width: 250px !important;
      .ant-typography-ellipsis-single-line {
        width: 90%;
      }
    }
    .ant-select-item-option-content:hover {
      color: #979797;
    }
    .any-link {
      .ant-select-item-option-content {
        font-size: 16px;
        color: #27ce0a;
        text-decoration: underline;
        text-decoration-color: #27ce0a;
      }
    }
    .text-underlined {
      text-decoration: underline;
      text-decoration-color: #979797;
      &.ant-select-item-option-content {
        color: #979797;
      }
      /* :hover {
        text-decoration-color: #27ce0a;
      } */
    }
    .ant-select-item-option-grouped {
      padding-left: 12px;
    }
    .removeBtn {
      background: #ffe9e9;
      border-radius: 5px;
      font-family: "Roboto";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: -0.35px;
      color: #d22121;
      padding: 4px 11px;
      margin-left: 16px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 11px;
      }
      :hover {
        cursor: pointer;
      }
    }
  }
  .condition-wrapper .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-checked) {
    color: #27ce0a;
  }
  .condition-wrapper .ant-radio-button-wrapper:first-child {
    border-radius: 6px 0 0 6px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: -0.35px;
  }
  .condition-wrapper .ant-radio-button-wrapper:last-child {
    border-radius: 0 6px 6px 0;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: -0.35px;
  }
`;
